module.exports = __webpack_public_path__ + "images/15ebdb8084cc557d70ddffaf1715eb6d-IMG_4503a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/bedroom/IMG_4503a.jpg
// module id = ./src/assets/images/slides/bedroom/IMG_4503a.jpg
// module chunks = 0